<template>
  <div>
    <el-dialog
      :visible.sync="modal.opened"
      :show-close="false">
      <div slot="title">
        <h4 class="title title-up">Отмена</h4>
      </div>
      <p>{{$t(`Do you really want to cancel the auto payment?`)}}</p>
      <template slot="footer">
        <el-button simple class="cancel-button" @click.native="modal.opened = false">{{ $t('No') }}</el-button>
        <el-button :loading="modal.loading" type="danger" @click.native="cancelAutoPayment(modal.paymentId)">{{ $t('Yes') }}</el-button>
      </template>
    </el-dialog>
    <el-table
      :data="payments"
      class="autopayments-table"
      v-loading="loading"
      v-if="payments.length">
      <el-table-column min-width="150" prop="agreement_number" :label="$t('Agreement')">
      </el-table-column>
      <el-table-column prop="amount" min-width="200" :label="$t('Sum')">
        <template slot-scope="scope">
          {{ formatPrice(scope.row.payment_summ) + ' ' + scope.row.cur_symbol }}
        </template>
      </el-table-column>
      <el-table-column min-width="150" prop="payment_day" :label="$t('Day of the month')">
      </el-table-column>
      <el-table-column min-width="150" prop="period_length" :label="$t('Write-off period')">
        <template slot-scope="scope">
          {{ $tc('month', scope.row.period_length) }}
        </template>
      </el-table-column>
      <el-table-column
        min-width="150"
        prop="last_payment"
        :label="$t('Last payment')"
        :formatter="formatDate"
      >
      </el-table-column>
      <el-table-column
        width="100"
        align="right">
        <template slot-scope="scope">
          <el-tooltip :content="$t('To cancel')" :open-delay="300" placement="top">
            <el-button size="small" @click.prevent.stop="confirmCancel(scope.row)" icon="el-icon-switch-button" type="danger" plain circle></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-empty v-else class="empty">
      <div slot="description" class="empty-description">
        <p>{{$t('You don\'t have any active auto payments yet')}}</p>
      </div>
    </el-empty>
  </div>
</template>

<script>
import { Table, TableColumn, Pagination, Button, DatePicker } from 'element-ui'
import { format, isValid } from 'date-fns'
import axios from 'axios'
import lang from 'element-ui/lib/locale/lang/ru-RU'
import locale from 'element-ui/lib/locale'
import number from './mixins/number'

locale.use(lang)

export default {
  name: 'AutopaymentsTable',
  mixins: [number],
  data () {
    return {
      payments: [],
      error: '',
      loading: false,
      paymentModal: {
        opened: false,
        loading: false
      },
      modal: {
        paymentId: null,
        opened: false,
        loading: false
      }
    }
  },
  created () {
    this.fetchAutoPayments()
  },
  methods: {
    fetchAutoPayments() {
      this.loading = true
      axios.get('autopayments', {
        params: {
          uid: this.uid
        }
      }).then(promise => {
        this.payments = promise.data.results
        this.loading = false
      }).catch(error => {
        console.log(error.response.data.error)
        this.loading = false
      })
    },
    confirmCancel: function(payment) {
      this.modal.paymentId = payment.record_id
      this.modal.opened = true
    },
    cancelAutoPayment(id) {
      this.modal.loading = true
      axios.post('autopayments/delete', {
        id: id
      }).then(promise => {
        this.modal.loading = false
        this.modal.opened = false
        this.payments = this.payments.filter((item) => item.record_id !== id)
        this.$notify(
          {
            message: 'Автоплатёж отменён',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'success',
            timeout: 1500
          })
      }).catch(error => {
        this.modal.opened = false
        this.modal.loading = false
        this.$notify(
          {
            message: error.message,
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger'
          })
      })
    },
    renderStatus(status) {
      // 'Статус автоплатежа: 0 - ожидает привязки способа оплаты, 1 - ожидает подтверждения тестового платежа, 2 - активен, 3 - отменен'
      switch (status) {
        case 2:
          return 'Активен'
        case 3:
          return 'Отменён'
        default:
          return 'Обрабатывается'
      }
    },
    formatDate(data) {
      const date = new Date(data.last_payment)
      if (!data.last_payment || !isValid(date)) {
        return '—'
      }
      return format(date, 'dd.MM.yyyy')
    }
  },
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    [Pagination.name]: Pagination,
    [DatePicker.name]: DatePicker
  }
}

</script>

<style scoped>
  .autopatments-table {
    margin-bottom: 10px;
  }
  .empty {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .empty >>> .el-empty__description {
    max-width: 600px;
  }
  .empty >>> .el-empty__image{
    width: 160px;
    margin-bottom: 32px;
  }

  .el-empty__description p {
    text-align: center;
  }

  .empty-description {
    text-align: center;
  }
  .empty-description p{
    margin-bottom: 10px;
  }

</style>
